let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("aHG2I"), load("bJvam"), load("aZXL0")]).then(() => parcelRequire('6Xyby'));